import { IBirth } from '../entities/IBirth';
import { DeliveryMethodEnum } from '../enums/DeliveryMethodEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateBirthParams {
  leadId: string;
  locationId?: string | null;
  expectedBirthDate?: string | null;
  birthDate?: string | null;
  babyName?: string | null;
  deliveryMethod?: DeliveryMethodEnum | null;
  photographyWishes?: string | null;
}

export interface IUpdateBirthParams {
  locationId?: string | null;
  expectedBirthDate?: string | null;
  birthDate?: string | null;
  babyName?: string | null;
  deliveryMethod?: DeliveryMethodEnum | null;
  photographyWishes?: string | null;
}

class BirthService {
  private _baseURL = 'births';

  getAll(leadId?: string): Promise<IBirth[]> {
    return httpClient.get<null, IBirth[]>(this._baseURL, {
      params: leadId ? { leadId } : undefined,
    });
  }

  create(data: ICreateBirthParams): Promise<IBirth> {
    return httpClient.post<null, IBirth>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateBirthParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new BirthService();
